// Mirrors the "Share via Email" behaviour from crux_ui's
// source/js/components/reports/dppr/ShareReport.jsx: build a mailto: link containing
// the generated report share link, then open it, instead of showing a modal/form.

export const REPORT_NAME_BY_TYPE = {
  cma: 'Comparative Market Analysis Report',
  rental: 'Rental Market Analysis Report',
  soi: 'Statement of Information',
  pps: 'Property Price Statement',
};

const getReportName = (reportType, propertyPriceStatement) => (
  reportType === 'soi' && propertyPriceStatement
    ? REPORT_NAME_BY_TYPE.pps
    : REPORT_NAME_BY_TYPE[reportType] || ''
);

export const buildShareEmailContent = ({reportType, propertyAddress, reportLink, site, propertyPriceStatement = false}) => {
  const reportName = getReportName(reportType, propertyPriceStatement);
  const addressHeading = `${reportName} - ${propertyAddress}`;
  const subject = addressHeading;
  const body = [
    addressHeading, reportLink, '', `Generated by Cotality ${site}.`,
  ].join('\r\n');

  return {subject, body};
};

// Ported from crux_ui's ShareReport.jsx: Firefox treats mailto: navigations
// differently than other browsers (loading it in the current tab breaks the page),
// so it needs a hidden iframe instead of an anchor click.
const openMailToFirefox = (mailToUrl) => {
  const mailToFrame = document.createElement('iframe');
  mailToFrame.className = 'share-report-iframe';
  mailToFrame.src = mailToUrl;
  mailToFrame.style.cssText = 'display: none';
  document.body.appendChild(mailToFrame);
  setTimeout(() => {
    document.body.removeChild(mailToFrame); // cleanup
  }, 1);
};

const openMailToDefault = (mailToUrl) => {
  const mailToLink = document.createElement('a');
  mailToLink.className = 'share-report-anchor';
  mailToLink.rel = 'noopener noreferrer';
  mailToLink.style.cssText = 'display: none';
  mailToLink.href = mailToUrl;
  document.body.appendChild(mailToLink);
  mailToLink.click();
  document.body.removeChild(mailToLink);
};

export const openShareEmail = ({reportType, propertyAddress, reportLink, site, propertyPriceStatement = false}) => {
  const {subject, body} = buildShareEmailContent({reportType, propertyAddress, reportLink, site, propertyPriceStatement});
  const mailToUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;

  if (isFirefox) {
    openMailToFirefox(mailToUrl);
  } else {
    openMailToDefault(mailToUrl);
  }
};

const ShareReportUtil = {REPORT_NAME_BY_TYPE, buildShareEmailContent, openShareEmail};

export default ShareReportUtil;
